export function messageFunc() {
	let messageTop = $("#messageTop").length;
	if(messageTop){
		let letZoomBtn, letImgBox, letModalImg, letMapBtn;
		letZoomBtn = $('.zoomBtn');
		letImgBox = $('.imgBox');
		letModalImg = $('.modalImg');
		letMapBtn = $('.mapBtn');
	  
		letZoomBtn.on('click', function () {
		  $(this).parent(letImgBox).addClass('open');
		  if (letImgBox.hasClass('open')) {
			$("#header").fadeOut();
			$(".breadcrumb").fadeOut();
			$(".scrPageTop").fadeOut();
		  }
		});
		
		letModalImg.on('click',function () {
		  if(!$(event.target).closest('img , p').length) {
			$(this).parent(letImgBox).removeClass('open');
			$("#header").show();
			$(".breadcrumb").show();
			$(".scrPageTop").show();
	  
			$(this).find('.mapImage').removeClass('hide');
			letMapBtn.parents('.attention').removeClass('hide');
			$(this).find('.mapScaleImage').addClass('hide');
			$(this).find('.backMapBtn').addClass('hide');
		  }
		});
	}
}